import { Box, Stack, Typography } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import { Control } from 'react-hook-form'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import { placeNames } from '../../../../../helpers/globalVariables'
import { getComp } from '../../../../../utils/utils/DI'
import { paymentNotifications } from '../../../consts/notifications.data'
import { RequestType } from '../../../types/Request.type'
import { mapChipValue } from '../../../utils/mapChipValue'
import FormAutocomplete from '../elements/FormAutocomplete'
import FormInput from '../elements/FormInput'
import FormSelect from '../elements/FormSelect'
import TypedAccordion from '../elements/TypedAccordion'
import WarnNotification from '../elements/WarnNotification'
import { BaseOptionType, ChangePaymentFormType } from '../helpers/getFormSchema'
import { dotationImageSx } from '../styles/styles'
import InputLabel from './InputLabel'

type PaymentAccordionProps = {
  isPaymentTypeSelected: boolean
  request: RequestType
  control: Control<ChangePaymentFormType>
  paymentItems: BaseOptionType[]
  reasonsItems: BaseOptionType[]
  districtOptions: BaseOptionType[]
  localitiesOptions: BaseOptionType[]
  fullDotationRegions: string[]
  locality: string | null
  onTerritoryChange: () => void
  onDistrictChange: () => void
}

const PaymentAccordion: React.FC<PaymentAccordionProps> = ({
  control,
  isPaymentTypeSelected,
  request,
  paymentItems,
  reasonsItems,
  districtOptions,
  fullDotationRegions,
  localitiesOptions,
  locality,
  onTerritoryChange,
  onDistrictChange,
}) => {
  const [showNotification, setShowNotification] = React.useState(true)
  const territoryStore = getComp('TerritoryStore')

  return (
    <TypedAccordion summary={'Тип оплаты'}>
      <Stack sx={{ padding: '16px' }}>
        {isPaymentTypeSelected ? (
          mapChipValue(request, 'financialSourceId')
        ) : (
          <Typography variant='body2'>Не выбран</Typography>
        )}
      </Stack>
      <Stack sx={formSx} spacing={'10px'}>
        <InputLabel label=' изменить тип оплаты'>
          <FormSelect
            control={control}
            fullWidth
            items={paymentItems}
            name='financialSourceId'
            placeholder='Выберите тип оплаты'
          />
        </InputLabel>
        <InputLabel label='Причина обращения'>
          <FormSelect
            control={control}
            fullWidth
            name='reasonId'
            items={reasonsItems}
            placeholder='Выберите причину обращения'
          />
        </InputLabel>
        <Stack py={'10px'}>
          {showNotification && (
            <WarnNotification
              notifications={paymentNotifications}
              setIsShown={setShowNotification}
              title='Изменение типа оплаты'
            />
          )}
        </Stack>
        <InputLabel label='Регион'>
          <FormAutocomplete
            control={control}
            fullWidth
            name='territory'
            options={territoryStore.collection as string[]}
            withoutTyping
            placeholder='Выберите регион'
            freeSolo
            onChange={onTerritoryChange}
            withUnknownValueError
          />
        </InputLabel>
        <InputLabel label='Округ'>
          <FormAutocomplete
            control={control}
            fullWidth
            name='district'
            options={districtOptions}
            placeholder='Выберите округ'
            freeSolo
            onChange={onDistrictChange}
            withUnknownValueError
          />
        </InputLabel>
        <InputLabel label='населённый пункт'>
          <FormAutocomplete
            control={control}
            fullWidth
            name='locality'
            options={localitiesOptions}
            placeholder='Выберите населённый пункт'
            fullDotationRegions={fullDotationRegions}
            freeSolo
          />
          {fullDotationRegions?.includes(locality ?? '') && (
            <Box sx={dotationImageSx}>
              <img src={getImageSrc('full-subsidy')} alt='full subsidy icon' />
            </Box>
          )}
        </InputLabel>
        <InputLabel label='Топоним'>
          <FormAutocomplete
            control={control}
            fullWidth
            name='addressType'
            options={placeNames}
            withoutTyping
            placeholder='Выберите топоним'
            freeSolo
          />
        </InputLabel>
        <InputLabel label='Наименование топонима'>
          <FormInput
            control={control}
            fullWidth
            name='address'
            placeholder='Выберите топоним'
          />
        </InputLabel>
        <Stack direction={'row'} spacing={'10px'} maxWidth={'100%'}>
          <InputLabel label='дом'>
            <FormInput
              control={control}
              fullWidth
              name='house'
              placeholder='Дом'
              onlyNumbers
            />
          </InputLabel>
          <InputLabel label='корпус'>
            <FormInput
              control={control}
              fullWidth
              name='building'
              placeholder='Корпус'
              onlyNumbersAndLetters
            />
          </InputLabel>
          <InputLabel label='квартира'>
            <FormInput
              control={control}
              fullWidth
              name='apartment'
              placeholder='Квартира'
              onlyNumbers
            />
          </InputLabel>
        </Stack>
      </Stack>
    </TypedAccordion>
  )
}

const formSx = { padding: '16px', borderTop: '1px solid #E0E0E0' }

export default observer(PaymentAccordion)
